import * as $ from "jquery";

export function addMobileLabels() {
   
    $('.ce-table').each(function() {
        let tableContainer = $(this);
        let i = 1;
        tableContainer.find('th strong').each(function() {
            tableContainer.find('tr td:nth-child('+i+')').attr('data-label',$(this).text());
            i++;
        });
    });
}